<template lang="pug">
v-card.pa-4.mt-4
  h1 Krediet maandbedrag berekenen

  v-divider.mb-4.mt-4

  FieldsLeaseDetails(
    v-model='leaseModel',
    :isBusinessLease='false',
    :pvInputAllowed='true',
    :calculateFunction='calculateFunction',
    :showRateField='true',
    :productType='"misc"'
    )

  v-divider.mb-4.mt-4

  small Door op "offerte aanvragen" te klikken kun je een aanvraag aanmaken maken en deze direct ter beoordeling indienen.

  v-layout(justify-end)
    v-btn(color='primary', :to='leaseParams') Offerte aanvragen
</template>

<script>
import axios from 'axios'

export default {
  name: 'CalcPrivateLease',

  components: {
    FieldsLeaseDetails: require('dealerfinanceservices-shared/src/FieldsLeaseDetails').default
  },

  data () {
    return {
      leaseModel: {
        nper: 60,
        ratePercentage: 6
      }
    }
  },

  computed: {
    leaseParams () {
      return {
        name: 'lease details',
        params: {
          leaseId: 'nieuwe-krediet-aanvraag'
        },
        query: {
          leasebedrag: this.leaseModel.pv,
          slottermijn: this.leaseModel.fv,
          looptijd: this.leaseModel.nper,
          aanbetaling: this.leaseModel.deposit
        }
      }
    }
  },

  methods: {
    async calculateFunction (params) {
      if (this.leaseModel.ratePercentage === undefined || this.leaseModel.ratePercentage === null || this.leaseModel.ratePercentage === '') throw new Error('cannot calc without rate')

      params.ratePercentage = this.leaseModel.ratePercentage

      const { data } = await axios({
        method: 'POST',
        url: `/calc/input/lease`,
        params
      })

      return data
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
